export const useDialog = ({ dialogProp = 'dialog', watchHandlerName } = {}) => ({
  model: {
    type: 'input',
    prop: 'value',
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    [dialogProp]: {
      get() {
        return this.value;
      },
      set(state) {
        this.$emit('input', state);
      },
    },
  },

  watch: {
    value: {
      handler(newValue) {
        if (this[watchHandlerName]) {
          this[watchHandlerName](newValue);
        }
      },
      immediate: true,
    },
  },
});
